var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Arrow-left v1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M2.43186 14.959L2.43318 14.9603L10.1265 22.0054C10.7029 22.5332 11.6351 22.5313 12.2088 22.0008C12.7824 21.4705 12.7802 20.6127 12.2039 20.0848L7.03856 15.3548H24.5276C25.3408 15.3548 26 14.7483 26 14C26 13.2517 25.3408 12.6451 24.5276 12.6451H7.03864L12.2038 7.91512C12.7802 7.38728 12.7824 6.52946 12.2087 5.99911C11.635 5.46862 10.7027 5.46679 10.1265 5.9945L2.43311 13.0397L2.43179 13.041C1.85514 13.5706 1.85698 14.4312 2.43186 14.959Z",
    fill: "#130F40"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowLeft);
export default __webpack_public_path__ + "static/media/icon-arrow-left.46585375082df4a3218df5071a1a7843.svg";
export { ForwardRef as ReactComponent };